import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { gridSpacing } from 'utils/constants';
import MainCard from 'components/Cards/MainCard';
import ReportFileExports from 'components/Reports/FileExports';
import ApiHelper from 'utils/apiHelper';
import ReportVisualization from 'components/Reports/ReportVisualization';

const ReportsLicenseSummary = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [licenseSummaryData, setLicenseSummaryData] = useState([]);
    const [totalLicenses, setTotalLicenses] = useState(0);
    const [usedLicenses, setUsedLicenses] = useState(0);
    const [filters, setFilters] = useState({});

    useEffect(() => {
        getLicenseSummaryData();
    }, []);

    const getLicenseSummaryData = () => {
        setLoading(true);
        ApiHelper.get('/api/reports/license_summary/')
            .then((res) => {
                setLicenseSummaryData(res.data.results);
                setTotalLicenses(res.data.total_licenses);
                setUsedLicenses(res.data.used_licenses);
                setLoading(false);
                setFilters({
                    report: 'License Summary',
                    filterData: []
                });
            })
            .catch((err) => {
                if (err.response.status !== 401) {
                    setLoading(false);
                    toast.warning('There is no license summary data');
                }
            });
    };

    return (
        <MainCard title="Operational Reports Management" cardHeaderTitle="License Summary" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={10}>
                    <Typography sx={{ fontSize: '16px' }}>
                        Provides a breakdown of licenses and their usage by the various devices
                    </Typography>
                </Grid>
                {licenseSummaryData.length > 0 && (
                    <Grid item xs={2}>
                        <ReportFileExports
                            setExportLoading={setExportLoading}
                            downloadFileName="license_summary"
                            downloadFileOption="all"
                            data={licenseSummaryData}
                            headers={[
                                { label: 'Issue Date', key: 'issue_date' },
                                { label: 'License Type', key: 'license_type' },
                                { label: 'License Total', key: 'total_licenses' },
                                { label: 'License Used', key: 'used_licenses' },
                                { label: 'License Left', key: 'left_licenses' },
                                { label: 'Expiration Date', key: 'expiration_date' }
                            ]}
                            filters={filters}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <ReportVisualization
                        loading={loading}
                        data={licenseSummaryData}
                        type="table"
                        tableHeaders={['Issue Date', 'License Type', 'License Total', 'License Used', 'License Left', 'Expiration Date']}
                        width={'100%'}
                        tableData={[
                            ...licenseSummaryData.map((data) => [
                                data.issue_date,
                                data.license_type,
                                data.total_licenses,
                                data.used_licenses,
                                data.left_licenses,
                                data.expiration_date
                            ]),
                            ['', '', totalLicenses.toString(), usedLicenses.toString(), (totalLicenses - usedLicenses).toString(), '']
                        ]}
                    />
                </Grid>
            </Grid>
            {exportLoading === true ? (
                <div className="overlayStyle">
                    <div className="spinner spinnerStyle"></div>
                </div>
            ) : null}
        </MainCard>
    );
};

export default ReportsLicenseSummary;
